import { type MCPServerInfo } from '../../types';

const SquareServer: MCPServerInfo = {
  serverId: 'SQUARE',
  name: 'Square',
  slug: 'square',
  description:
    "Access Square's commerce platform to view transaction data, manage customer profiles, track inventory, process payments, and analyze sales patterns. Handle point-of-sale operations, generate financial reports, and manage business operations.",
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.squareup.com/sse',
    transport: 'SSE'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default SquareServer;
